import { FC } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { ListPageTitle } from 'components/atoms/ListPageTitle';

type Props = {
  handleClickRegistration: () => void;
};

export const NotificationHeaderView: FC<Props> = ({
  handleClickRegistration,
}) => (
  <Box m="40px 5px 0 5px">
    <Flex justifyContent="space-between" alignItems="center" h="40px">
      <ListPageTitle title="お知らせ管理" />
      <Button colorScheme="blue" size="sm" onClick={handleClickRegistration}>
        お知らせ新規作成
      </Button>
    </Flex>
  </Box>
);
